export default {
    path: "/reports",
    component: () => import("~/pages/reports/index.vue"),
}